import { AxiosPromise } from 'axios';
import { IThemeFormValues } from '../form';
import { instance } from '../../../../services';

const updateTheme = (data: IThemeFormValues): AxiosPromise => {
  const { id } = data;

  return instance.put(`/api/themes/${id}`, data);
};

export default updateTheme;
